import User from '../../types/User';

export const SET_USER = 'user/SET_USER';
export const UPDATE_PREFERENCES = 'user/UPDATE_PREFERENCES';
export const SET_PROGRAM_CBTN_USERNAME = 'user/SET_PROGRAM_CBTN_USERNAME';

export function setUserAction(user:User) {
  return {
    type: SET_USER,
    user,
  };
}

export function setProgramCbtnUsername(programCbtnUsername: string | null) {
  return {
    type: SET_PROGRAM_CBTN_USERNAME,
    programCbtnUsername,
  };
}

export function setAndUpdateUserPreferencesAction(preferences:any) {
  return {
    type: UPDATE_PREFERENCES,
    preferences,
  };
}

